import "./Loading.css";

export default function LoadingScreen() {
  return (
    <div className="loading-screen">
      <h2>Loading ...</h2>
    </div>
  );
}